import { supabaseManager } from '@/services/supabaseManager';
import { AuthChangeEvent, Session } from '@supabase/supabase-js';

type AuthStateChangeCallback = (event: AuthChangeEvent, session: Session | null) => Promise<void>;

class AuthEventManager {
  private static instance: AuthEventManager;
  private subscription: any = null;
  private callback: AuthStateChangeCallback | null = null;

  private constructor() {}

  static getInstance(): AuthEventManager {
    if (!AuthEventManager.instance) {
      AuthEventManager.instance = new AuthEventManager();
    }
    return AuthEventManager.instance;
  }

  setAuthStateChangeCallback(callback: AuthStateChangeCallback) {
    this.callback = callback;
    this.setupListener();
  }

  setupOrganizationClientListener() {
    this.setupListener();
  }

  private setupListener() {
    this.cleanup();

    let client;
    try {
      client = supabaseManager.getCurrentClient();
    } catch {
      client = supabaseManager.getMainClient();
    }

    const { data: { subscription } } = client.auth.onAuthStateChange(
      async (event, session) => {
        if (this.callback) {
          await this.callback(event, session);
        }
      }
    );

    this.subscription = subscription;
  }

  cleanup() {
    this.subscription?.unsubscribe();
    this.subscription = null;
  }
}

export const authEventManager = AuthEventManager.getInstance();
